// extracted by mini-css-extract-plugin
export default {"titleLoadingSkeleton":"HeaderLoading-module__titleLoadingSkeleton--xejEX","metadataLoadingSkeleton":"HeaderLoading-module__metadataLoadingSkeleton--KVtbP"};